import { matchPath } from 'react-router-dom';
import { HEALTH_INSURANCE_BASE_PATH } from '@/utils/rhiV2/journey';
import type { RhiVersion } from '@/utils/rhiVersion';

export type RhiRouteOwner = RhiVersion | 'shared';

/** Every child of the `health-insurance` route, keyed by its path as the router declares it. */
export const RHI_ROUTE_OWNERS: Record<string, RhiRouteOwner> = {
  '': 'shared',
  'select-member': 'shared',
  'thank-you': 'shared',
  error: 'shared',
  // A v2 home still sends a customer with a v1 policy here, so both versions must reach it.
  'policy-status': 'shared',
  'policy-status/:status': 'shared',

  recommendation: 'v1',
  'plans-benefits': 'v1',
  'add-riders/:planId': 'v1',
  'verify-details': 'v1',
  'add-nominee': 'v1',
  'member-details': 'v1',
  'member-details/:relation': 'v1',
  checkout: 'v1',
  'bank-details': 'v1',

  agent: 'v2',
  plans: 'v2',
  'plans/:planId': 'v2',
  'kyc/:planId': 'v2',
  'proposal/:planId': 'v2',
  'proposal/:planId/review': 'v2',
  'payment/:planId': 'v2',
  'policy/:planId': 'v2',
};

export const getRhiRouteOwner = (pathname: string): RhiRouteOwner | undefined => {
  const routePath = Object.keys(RHI_ROUTE_OWNERS).find((path) =>
    matchPath(
      { path: path ? `${HEALTH_INSURANCE_BASE_PATH}/${path}` : HEALTH_INSURANCE_BASE_PATH },
      pathname,
    ),
  );
  return routePath === undefined ? undefined : RHI_ROUTE_OWNERS[routePath];
};

export const isRhiRouteOpenTo = (pathname: string, version: RhiVersion): boolean => {
  const owner = getRhiRouteOwner(pathname);
  return !owner || owner === 'shared' || owner === version;
};
